<template>
  <div class="table-container" id="hkstockspost">
    <h1>发布决战港股场次信息</h1>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="活动标题">
        <el-input v-model="form.title"></el-input>
      </el-form-item>

      <el-form-item label="举办城市">
        <el-input v-model="form.city"></el-input>
      </el-form-item>

      <el-form-item label="举办地址">
        <el-input v-model="form.address" placeholder="街道地址"></el-input>
      </el-form-item>

      <el-form-item label="举办地点">
        <el-input v-model="form.position" placeholder="具体的建筑物地点"></el-input>
      </el-form-item>

      <el-form-item label="人数限制">
        <el-input v-model="form.limit"></el-input>
      </el-form-item>
      <el-form-item label="举办时间">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="开放状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="视频类型">
        <el-radio-group v-model="form.videoType">
          <el-radio :label="0">直播</el-radio>
          <el-radio :label="1">回放</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="视频上传">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="headerSuccess"
          :on-remove="headerRemove"
        >
          <el-button size="small" type="primary">
            上传视频
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.header" placeholder="相同视频可以复制之前已上传后的链接粘贴于此，可节省大量时间"/>
      </el-form-item>
      <el-form-item label="上传报名头图" label-width="100px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="footerSuccess"
          :on-remove="footerRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.footer" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <el-form-item label="视频开放状态" label-width="100px">
        <el-radio-group v-model="form.dtbShow">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="资讯开放状态" label-width="100px">
        <el-radio-group v-model="form.msgShow">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="花絮开放状态" label-width="100px">
        <el-radio-group v-model="form.titbitShow">
          <el-radio :label="1">开放</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <h1>议程图片：</h1>
      <h2>上午议程</h2>
      <el-form-item label="上午议程PC" label-width="150px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="agandaAmPcSuccess"
          :on-remove="footerRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.aganda_am_pc" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <el-form-item label="上午议程MB" label-width="150px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="agandaAmMbSuccess"
          :on-remove="footerRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.aganda_am_mb" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <h2>下午议程</h2>
      <el-form-item label="下午议程PC" label-width="150px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="agandaPmPcSuccess"
          :on-remove="footerRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.aganda_pm_pc" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <el-form-item label="下午议程MB" label-width="150px">
        <el-upload
          :action="oss.host"
          :data="oss"
          class="one-line-upload"
          :on-success="agandaPmMbSuccess"
          :on-remove="footerRemove"
        >
          <el-button size="small" type="primary">
            上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
        <el-input v-model="form.aganda_pm_mb" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <!-- <h1>决战港股首页弹出信息：</h1>
      <el-form-item label="协办单位">
        <el-input v-model="form.coOrganizers" placeholder="协办单位"></el-input>
      </el-form-item>
      <el-form-item label="支持单位">
        <el-input v-model="form.supporters" placeholder="支持单位"></el-input>
      </el-form-item>
      <el-form-item label="战略赞助">
        <el-input v-model="form.Ssponsorship" placeholder="战略赞助"></el-input>
      </el-form-item>
      <el-form-item label="协办媒体">
        <el-input v-model="form.supportMeadia" placeholder="协办媒体"></el-input>
      </el-form-item>
      <el-form-item label="合作媒体">
        <el-input v-model="form.mediaPartners" placeholder="合作媒体"></el-input>
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="pushData" v-if="!id">发布信息</el-button>
        <el-button type="primary" @click="putData" plain v-if="id">更新信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: null,
        city: null,
        address: null,
        position: null,
        startTime: new Date().getTime(),
        expireTime: new Date().getTime(),
        limit: null,
        status: 1,
        header: null,
        coOrganizers: null,
        supporters: null,
        Ssponsorship: null,
        supportMeadia: null,
        mediaPartners: null,
        footer: null,
        dtbShow: 0,
        msgShow: 0,
        titbitShow: 0,
        aganda_am_pc: "",
        aganda_am_mb: "",
        aganda_pm_pc: "",
        aganda_pm_mb: "",
        videoType: 0
      },
      dateRange: [new Date(), new Date()],
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      }
    };
  },
  watch: {
    id() {
      this.getData();
    }
  },
  methods: {
    headerSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.header = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    footerSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.footer = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    agandaAmPcSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.aganda_am_pc = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    agandaAmMbSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.aganda_am_mb = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    agandaPmPcSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.aganda_pm_pc = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    agandaPmMbSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.aganda_pm_mb = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },

    headerRemove() {
      this.form.header = null;
    },
    footerRemove() {
      this.form.footer = null;
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    getData(id) {
      this.$http.hkstocks_detail(id).then(res => {
        if (res.data.statusCode === 200) {
          const {
            title,
            address,
            position,
            city,
            startTime,
            expireTime,
            status,
            limit,
            header,
            coOrganizers,
            supporters,
            Ssponsorship,
            supportMeadia,
            mediaPartners,
            footer,
            dtbShow,
            msgShow,
            titbitShow,
            aganda_am_pc,
            aganda_am_mb,
            aganda_pm_pc,
            aganda_pm_mb,
            videoType
          } = res.data.result;
          this.form.title = title;
          this.form.address = address;
          this.form.position = position;
          this.form.city = city;
          this.dateRange = [startTime, expireTime];
          this.form.status = status;
          this.form.limit = limit;
          this.form.header = header;
          this.form.footer = footer;
          this.form.coOrganizers = coOrganizers;
          this.form.supporters = supporters;
          this.form.Ssponsorship = Ssponsorship;
          this.form.supportMeadia = supportMeadia;
          this.form.mediaPartners = mediaPartners;
          this.form.dtbShow = dtbShow;
          this.form.msgShow = msgShow;
          this.form.titbitShow = titbitShow;
          this.form.aganda_am_pc = aganda_am_pc;
          this.form.aganda_am_mb = aganda_am_mb;
          this.form.aganda_pm_pc = aganda_pm_pc;
          this.form.aganda_pm_mb = aganda_pm_mb;
          this.form.videoType = videoType;
        } else {
          this.form.title = null;
          this.form.address = null;
          this.form.city = null;
          this.dateRange = [new Date(), new Date()];
          this.form.status = 1;
          this.form.videoType = 0;
          this.form.limit = null;
          this.form.footer = null;
        }
      });
    },
    pushData() {
      this.form.startTime = new Date(this.dateRange[0]).getTime();
      this.form.expireTime = new Date(this.dateRange[1]).getTime();
      this.$http
        .hkstocks_post({
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/hkstocks");
            this.$message({
              message: "发布活动成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    putData() {
      this.form.startTime = new Date(this.dateRange[0]).getTime();
      this.form.expireTime = new Date(this.dateRange[1]).getTime();
      this.$http
        .hkstocks_put({
          id: this.id,
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/hkstocks");
            this.$message({
              message: "更新活动成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  mounted() {
    this.getOssSign();
    if (this.id) {
      this.getData(this.id);
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped>
.one-line-upload {
  display: inline-block;
  vertical-align: top;
}

h2 {
  font-size: 18px;
  padding-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/backend/hkstockspost.vue